import { useContext } from "react";
import { InlineEditorContext } from "./InlineEditorContext";

const useInlineEditorContext = () => useContext(InlineEditorContext);

export default useInlineEditorContext;
